var map = {
	"./address_image.svg": 174,
	"./animated_logo.svg": 175,
	"./blogs_image.svg": 176,
	"./cloud_infrastructure.svg": 177,
	"./contactMail.png": 178,
	"./developerActivity.svg": 179,
	"./education.svg": 180,
	"./experience.svg": 181,
	"./feelingProud.svg": 182,
	"./freecodecamp-logo.webp": 183,
	"./freecopy_logo.png": 184,
	"./fullstack.svg": 185,
	"./gcp_logo.png": 186,
	"./github_logo.png": 187,
	"./googleAssistant.jpg": 188,
	"./googleAssistant.svg": 189,
	"./google_logo.png": 190,
	"./infostack_tech_logo.jpg": 191,
	"./jsFramework.svg": 192,
	"./manOnTable.svg": 193,
	"./microsoft_logo.png": 194,
	"./mozilla_logo.png": 195,
	"./muffito_logo.png": 196,
	"./nextuLogo.jpg": 197,
	"./nptel_logo.png": 198,
	"./portfolio.gif": 199,
	"./programmer.svg": 200,
	"./projects_image.svg": 201,
	"./pucit.png": 202,
	"./pwa.png": 203,
	"./talksCardBack.svg": 204,
	"./talksCardBackAlt.svg": 205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;